/**
 * WhatsApp message history is no longer shown — with click-to-chat (wa.me) the
 * message is sent from the staff member's own WhatsApp, so delivery can't be
 * tracked in-app. Kept as a no-op so the screens that render it stay clean.
 */
export function WhatsAppLog() {
  return null;
}
